import { createAsyncThunkFromFetch } from 'src/store/utils';
import { BillingQueryParams, BillingResponse } from './billing.types';
import { getBilling, getShortBilling } from './billing.api';

const prefix = 'billing';

export const fetchBillingAction = createAsyncThunkFromFetch<
  BillingResponse,
  {
    params?: BillingQueryParams;
  }
>(`${prefix}/fetchBilling`, getBilling);

export const fetchBillingForExportAction = createAsyncThunkFromFetch<
  BillingResponse,
  {
    params?: BillingQueryParams;
  }
>(`${prefix}/fetchBillingForExport`, getBilling);

export const fetchShortBillingAction = createAsyncThunkFromFetch<
  BillingResponse,
  {
    params?: BillingQueryParams;
  }
>(`${prefix}/fetchShortBilling`, getShortBilling);
